<template>
    <section class="administration-profile">
        <div class="form">
            <div class="grid-x">
                <div style="width: 40px;"></div>
                <div class="cell small-3"></div>
                <div class="cell auto flexbox-center" style="max-width: 350px;">
                    <icon class="huge-svg fill-dark-gray" name="user" />
                </div>
            </div>
        </div>

        <hr/>

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="envelope" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="userEmail">E-mail</label>
                </div>
                <div class="cell auto">
                    <email-validation id="userEmail" :existingUser="tempUser.email" v-model="tempUser.email" @validateEmail="validEmailResult" />
                </div>
            </div>
        </div>

        <hr/>

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="user" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="userName">Navn</label>
                </div>
                <div class="cell auto">
                    <input type="text" id="userName" ref="username" v-model="tempUser.name" />
                </div>
            </div>
        </div>

        <hr/>

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="phone" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label for="userPhone">Telefon</label>
                </div>
                <div class="cell auto">
                    <input type="text" id="userPhone" v-model="tempUser.phoneNumber" />
                </div>
            </div>
        </div>

        <hr/>

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="locked" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label>Adgangskode</label>
                </div>
                <div class="cell auto">
                    <button class="button button-form blue" @click="changePassword()">Skift adgangskode</button>
                </div>
            </div>
        </div>

        <hr/>

        <!-- SKAL FIXES -->
        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="notification" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label>Notifikationer</label>
                </div>
                <div class="cell auto">
                    <!-- Enquiry -->
                    <div class="grid-x" style="margin-bottom: 10px;">
                        <div class="large-3 medium-3 small-3 cell" style="min-width: 165px;">
                            <span style="margin-left: 9px;"><b>Henvendelser</b></span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="enabledEnquiry" theme="custom" type-bold="false" color="blue" />
                            <span v-if="enabledEnquiry" style="color:">Aktiv</span>
                            <span v-else>Ikke aktiv</span>
                        </div>
                    </div>

                    <!-- Task -->
                    <div class="grid-x" style="margin-bottom: 10px;">
                        <div class="large-3 medium-3 small-3 cell" style="min-width: 165px;">
                            <span style="margin-left: 9px;"><b>Opgaver</b></span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="enabledTask" theme="custom" type-bold="false" color="blue" />
                            <span v-if="enabledTask" style="color:">Aktiv</span>
                            <span v-else>Ikke aktiv</span>
                        </div>
                    </div>

                    <!-- Requisitions -->
                    <div class="grid-x" style="margin-bottom: 10px;">
                        <div class="large-3 medium-3 small-3 cell" style="min-width: 165px;">
                            <span style="margin-left: 9px;"><b>Entreprenøropgaver</b></span>
                        </div>
                        <div class="auto cell">
                            <switches v-model="enabledRequisition" theme="custom" type-bold="false" color="blue" />
                            <span v-if="enabledRequisition" style="color:">Aktiv</span>
                            <span v-else>Ikke aktiv</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <hr/>

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="supply-type" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label>Standard forretningsomr&aring;de</label>
                </div>
                <div class="cell auto">
                    <select v-model="uiSettings.defaultBusinessAreaTypeId">
                        <option v-for="(businessArea, index) in businessAreaTypeList" :key="businessArea.code" :selected="uiSettings.defaultBusinessAreaTypeId === businessArea.sysBusinessAreaTypeId || index === 0 ? true : null" :value="businessArea.sysBusinessAreaTypeId">{{ businessArea.description }}</option>
                    </select>
                </div>
            </div>
        </div>

        <hr/>

        <div class="form">
            <div class="grid-x">
                <div class="flexbox-center">
                    <icon class="small-label-svg" name="enquiry" />
                </div>
                <div class="cell small-3 flexbox align-items">
                    <label>Startfane på eksisterende henvendelser</label>
                </div>
                <div class="cell auto">
                    <select v-model="uiSettings.requestStartTabNumber">
                        <option :value="0">Historik</option>
                        <option :value="2">Problem</option>
                    </select>
                </div>
            </div>
        </div>

        <hr/>

        <div class="form">
            <div class="grid-x">
                <div style="width: 40px;"></div>
                <div class="cell small-3"></div>
                <div class="cell auto">
                    <button class="button button-form-primary" :class="{ 'disabled-button': validateFields }" @click="save()">{{ buttonLabel }}</button>
                </div>
            </div>
        </div>

        <modal v-if="showModal" :type="modalType" @close="closeModal" />
    </section>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Switches from 'vue-switches'
    import modal from './../../shared/modal/modal.vue'
    import emailValidation from './../../shared/email/email-validation.vue'

    export default {
        data () {
            return {
                validEmail: true,
                showModal: false,
                modalType: null,
                buttonLabel: 'Gem',
                tempUser: {},
                // notifications
                enabledEnquiry: false,
                enabledTask: false,
                enabledRequisition: false,
                uiSettings: {
                    defaultBusinessAreaTypeId: null,
                    requestStartTabNumber: 2
                }
            }
        },
        components: {
            Switches,
            'modal': modal,
            'email-validation': emailValidation
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                applicationList: 'getApplicationList',
                applicationSettings: 'getApplicationSettingsDrive',
                businessAreaTypeList: 'getSysBusinessAreaTypeList'
            }),
            validateFields () {
                if (this.tempUser.name && this.tempUser.email && this.validEmail) {
                    return false
                } else {
                    return true
                }
            }
        },
        methods: {
            ...mapActions({
                setUserProperties: 'setUserProperties',
                setEmployee: 'setEmployee',
                updateDriveUserEmailSetting: 'updateDriveUserEmailSetting',
                setUserUiSettings: 'setUserUiSettings',
                setApplication: 'setApplication',
                setAllCodeLists: 'setAllCodeLists',
                setApplicationSettingsDrive: 'setApplicationSettingsDrive'
            }),
            changePassword () {
                this.showModal = true
                this.modalType = 'administration-modal-newpassword'
            },
            closeModal () {
                this.showModal = false
            },
            validEmailResult (result) {
                this.validEmail = result
            },
            save () {
                this.buttonLabel = 'Gemmer...'
                if (this.validEmail) {
                    new Promise((resolve, reject) => {
                        this.tempUser.emailCc = ''
                        resolve(this.setUserProperties(this.tempUser))
                    }).then(() => {
                        let emailSettingsObj = {
                            'sendRequestEmailToUser': this.enabledEnquiry,
                            'sendTaskEmailToUser': this.enabledTask,
                            'sendRequisitionEmailToUser': this.enabledRequisition
                        }
                        this.setUserUiSettings(this.uiSettings)
                        return this.updateDriveUserEmailSetting(emailSettingsObj)
                    }).then(() => {
                        this.buttonLabel = 'Gem'
                    })
                }
            },
            setMailEnabled () {
                let userSetting = this.applicationSettings.find(a => a.category === 'user_setting' && a.name === 'send_email')
                if (userSetting) {
                    if (userSetting.value.SendRequestEmailToUser) {
                        this.enabledEnquiry = true
                    }

                    if (userSetting.value.SendTaskEmailToUser) {
                        this.enabledTask = true
                    }

                    if (userSetting.value.SendRequisitionEmailToUser) {
                        this.enabledRequisition = true
                    }
                }
            },
            setUiSettings () {
                const userSetting = this.applicationSettings.find(a => a.category === 'user_setting' && a.name === 'ui')
                if (userSetting && userSetting.value.RequestStartTabNumber !== null) {
                    this.uiSettings.requestStartTabNumber = userSetting.value.RequestStartTabNumber
                }
                if (userSetting && userSetting.value.DefaultBusinessAreaTypeId !== null) {
                    this.uiSettings.defaultBusinessAreaTypeId = userSetting.value.DefaultBusinessAreaTypeId
                }
            }
        },
        watch: {
            user (val, oldVal) {
                this.tempUser = val
                this.setEmployee(this.tempUser)
                if (this.tempUser.email) {
                    this.$nextTick(() => this.$refs.username.focus())
                }
            },
            applicationSettings (val, oldVal) {
                if (val) {
                    this.setMailEnabled()
                    this.setUiSettings()
                }
            }
        },
        created () {
            if (this.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
                new Promise((resolve, reject) => {
                    resolve(this.setApplication(this.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].key))
                }).then(() => {
                    this.setAllCodeLists()
                    this.setApplicationSettingsDrive()
                })
            }
            if (this.user) {
                this.tempUser = this.user
                this.setEmployee(this.user)
            }
            this.setApplicationSettingsDrive()
            if (this.applicationSettings) {
                this.setMailEnabled()
                this.setUiSettings()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-profile.vue